import React from 'react';

import Card from '../Card/Card';
import FormInput from './FormInput/FormInput';
import FormText from './FormText/FormText';

import styles from './Form.module.scss';

export interface FormPropsI {
  children?: React.ReactNode;
  heading?: string;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  headerRight?: React.ReactNode;
  footer?: React.ReactNode;
}

const Form = ({ children, heading, onSubmit, headerRight, footer }: FormPropsI): JSX.Element => {
  return (
    <Card width="auto">
      <form
        className={styles.Form}
        onSubmit={onSubmit}
        autoComplete="on"
        style={{ paddingBottom: footer ? '0px' : undefined }}
      >
        <div className={styles.header}>
          <h2 className={styles.Form__heading}>{heading}</h2>
          {headerRight}
        </div>
        {children}
      </form>
      {footer && <div className={styles.footer}>{footer}</div>}
    </Card>
  );
};

Form.FormInput = FormInput;
Form.FormText = FormText;

export default Form;
